type Props = {
  title: string;
  body: string;
  onAccept?: () => void;
  onReject?: () => void;
  onEdit?: () => void;
};

export default function BrainSuggestionCard({ title, body, onAccept, onReject, onEdit }: Props) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-2 text-sm font-semibold text-slate-900">{title}</div>
      <p className="text-sm text-slate-700">{body}</p>
      <div className="mt-3 flex gap-2">
        <button type="button" onClick={onAccept} className="rounded-md bg-green-600 px-3 py-1.5 text-xs text-white">
          Accept
        </button>
        <button type="button" onClick={onReject} className="rounded-md bg-rose-600 px-3 py-1.5 text-xs text-white">
          Reject
        </button>
        <button type="button" onClick={onEdit} className="rounded-md bg-amber-600 px-3 py-1.5 text-xs text-white">
          Edit
        </button>
      </div>
    </div>
  );
}
